export default function Pricing() {
  const plans = [
    {
      name: 'Starter',
      price: '85€',
      credits: '1 000 crédits/mois',
      detail: '0.085€/crédit',
      features: ['Recherche de prospects', 'Enrichissement de base', 'Campagnes email', '1 utilisateur'],
      featured: false,
    },
    {
      name: 'Pro',
      price: '380€',
      credits: '5 000 crédits/mois',
      detail: '0.076€/crédit',
      features: ['Tout Starter, plus :', 'Enrichissement avancé', 'LinkedIn + SMS', 'Personnalisation IA', '3 utilisateurs'],
      featured: true,
    },
    {
      name: 'Business',
      price: '1 100€',
      credits: '15 000 crédits/mois',
      detail: '0.073€/crédit',
      features: ['Tout Pro, plus :', 'Intégrations CRM', 'API access', 'Utilisateurs illimités', 'Account manager'],
      featured: false,
    },
    {
      name: 'Enterprise',
      price: '3 500€',
      credits: '50 000 crédits/mois',
      detail: '0.070€/crédit',
      features: ['Tout Business, plus :', 'Support prioritaire 24/7', 'Onboarding dédié', 'SLA garanti', 'Développements sur mesure'],
      featured: false,
      ctaText: 'Nous contacter',
    },
  ]

  return (
    <div id="pricing" className="pricing-section">
      <div className="container-narrow">
        <div className="section-header">
          <h2>Tarification</h2>
          <p className="section-description">Transparence totale, pas de frais cachés</p>
        </div>

        <div className="pricing-grid">
          {plans.map((plan, i) => (
            <div key={i} className={`pricing-card ${plan.featured ? 'featured' : ''}`}>
              {plan.featured && <div className="pricing-badge">Le plus populaire</div>}
              <div className="pricing-header">
                <h3>{plan.name}</h3>
                <div className="price">
                  <span className="amount">{plan.price}</span>
                  <span className="period">/mois</span>
                </div>
                <p className="credits">{plan.credits}</p>
                <p className="price-detail">{plan.detail}</p>
              </div>
              <ul className="pricing-features">
                {plan.features.map((feature, j) => (
                  <li key={j}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M16 6L8 14L4 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>
              <button className={`btn ${plan.featured ? 'btn-primary' : 'btn-secondary'} btn-full`}>{plan.ctaText || 'Commencer'}</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
